import * as React from 'react';
import Div from "@jumbo/shared/Div";
import ContentWrapper from 'app/components/ContentWrapper/ContentWrapper';
import { Typography } from "@mui/material";
import MobileFooter from 'app/components/MobileFooter/MobileFooter';
import MobileHeader from 'app/components/MobileHeader/MobileHeader';
import InputIcon from 'app/components/InputIcon/InputIcon';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import DescriptionIcon from '@mui/icons-material/Description';
import Checkbox from '@mui/material/Checkbox';
import Link from "@mui/material/Link";
import EmailIcon from '@mui/icons-material/Email';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import { useNavigate } from "react-router-dom";
import SnK from 'app/components/Modal/SnK';
import { generateOTP, setupOTP, setupParams } from 'app/services/setupWebview';
import ButtonStyled from 'app/components/ButtonStyled/ButtonStyled';
import Swal from 'sweetalert2';
import { isMobile } from 'react-device-detect';
import { useProgram } from 'app/hooks/useProgram';
import { removeOtpSession } from '@jumbo/components/JumboAuthProvider/authHelpers';
import { ERROR_SERVER_DEFAULT } from 'app/utils/appHelpers';

const WebViewRegistrasi = () => {

	const program = useProgram()

	React.useEffect(() => {
		// if (!isMobile) {
		// 	Swal.fire({
		// 		icon: 'warning',
		// 		title: 'Forbidden!',
		// 		text: 'Halaman ini tidak dapat diakses melalui browser',
		// 		allowOutsideClick: false,
		// 		showConfirmButton: false
		// 	});
		// }
	}, []);
	const navigate = useNavigate();
	const [openSnK, setOpenSnk] = React.useState(false);
	const [params, setParams] = React.useState(null);
	const [isChecked, setIsChecked] = React.useState(false);

	const navigateBack = React.useCallback(() => {
		removeOtpSession()
		var params = localStorage.getItem('params') ? localStorage.getItem('params') : ""
		navigate('/webViewLogin' + params)
	}, [navigate])

	React.useEffect(() => {
		if (!params) {
			var parameter = localStorage.getItem('params')
			setupParams(parameter, setParams, false, navigateBack)
		}
	}, [navigateBack, params]);

	const handleClickOpenSnk = () => () => {
		setOpenSnk(true);
	};

	const isSubmittingRef = React.useRef(false);

	const navigateNext = async () => {
		if (isSubmittingRef.current) return;
		
		if (!params.kode) {
			Swal.fire({
				icon: 'warning',
				text: 'Invalid Agent Code!',
				allowOutsideClick: false,
				confirmButtonColor: 'red'
			})
			return
		} else {
			isSubmittingRef.current = true;
			navigate('/webViewOtpVerification');
			setTimeout(() => { isSubmittingRef.current = false; }, 1000);
		}
	};

	const handleCheckboxChange = (event) => {
		setIsChecked(event.target.checked);
	};

	const checkOTP = async () => {
		const time = new Date().getTime();
		const timerDurationMinutes = setupOTP.timerDurationMinutes;
		const maxRestartLimit = setupOTP.maxRestartLimit;
		const restartDelayMinutes = setupOTP.restartDelayMinutes

		const now = new Date().getTime();
		var exp = localStorage.getItem('expiryTime') || time + timerDurationMinutes * 60 * 1000;
		var exp2 = localStorage.getItem('restartAvailableTime') || 0;
		const restartCount = localStorage.getItem('restartCount') || 0;
		var newRestartAvailableTime = now + restartDelayMinutes * 60 * 1000;
		let newRestartCount = parseInt(restartCount) + 1;

		if (now >= exp || !localStorage.getItem('expiryTime')) {
			if (restartCount >= maxRestartLimit && now < parseInt(exp2)) {
				Swal.close();
				navigate('/webViewOtpVerification');
			} else {
				if (newRestartCount >= maxRestartLimit && !localStorage.getItem('restartAvailableTime')) {
					localStorage.removeItem('expiryTime')
					localStorage.setItem('restartCount', newRestartCount)
					localStorage.setItem('restartAvailableTime', newRestartAvailableTime.toString());
				} else if (newRestartCount < maxRestartLimit) {
					localStorage.removeItem('expiryTime')
					localStorage.setItem('restartCount', newRestartCount)
				} else {
					localStorage.removeItem('expiryTime')
					localStorage.setItem('restartCount', 1)
					localStorage.removeItem('restartAvailableTime')
				}
				// 		Swal.close();
				// 		navigate('/webViewOtpVerification');
				await generateOTP(params.kode, params.nama, "TNC_REGIS").then((data) => {
					Swal.close();
					if (data.status === 'success') {
						navigate('/webViewOtpVerification');
					} else {
						setTimeout(() => {
							Swal.fire({
								icon: 'warning',
								text: data?.message || ERROR_SERVER_DEFAULT,
								allowOutsideClick: false,
								confirmButtonColor: 'red'
							})
						}, 1000);
					}
				}).catch((err) => {
					Swal.close();
					setTimeout(() => {
						Swal.fire({
							icon: 'warning',
							text: err?.message || ERROR_SERVER_DEFAULT,
							allowOutsideClick: false,
							confirmButtonColor: 'red'
						})
					}, 1000);
				})
			}
		} else {
			Swal.close();

			// if(newRestartCount >= maxRestartLimit && !localStorage.getItem('restartAvailableTime')){
			// 	localStorage.setItem('restartAvailableTime', newRestartAvailableTime.toString());
			// }
			navigate('/webViewOtpVerification');
		}
	}

	return (
		<Div className='page-wrapper-mobile'>

			{/* 🔥 HEADER */}
			<MobileHeader
				backIcon
				headerTx={"Registrasi"}
				backOnClick={navigateBack}
			/>

			{/* 🔥 CONTENT */}
			{params &&
				<ContentWrapper isMobile>

					{/* 🔥 typography */}
					<Typography fontSize={16} fontWeight={600}>Silakan Lengkapi Data Diri Anda</Typography>


					{/* 🔥 input with icon left/right */}
					<Div sx={{ mt: 2 }}>
						<Div sx={{ mb: 2 }}>
							<InputIcon
								disabled
								inputLabel={"Nama Lengkap Agen"}
								placeholder={""}
								value={params.nama}
								leftIcon={<AccountCircleIcon sx={{ fontSize: 24 }} />}
							/>
						</Div>
						<Div sx={{ mb: 2 }}>
							<InputIcon
								disabled
								inputLabel={"Kode Agen"}
								placeholder={""}
								value={params.kode}
								leftIcon={<DescriptionIcon sx={{ fontSize: 24 }} />}
							/>
						</Div>
						<Div sx={{ mb: 2 }}>
							<InputIcon
								disabled
								inputLabel={"Email"}
								placeholder={""}
								value={params.email}
								leftIcon={<EmailIcon sx={{ fontSize: 24 }} />}
							/>
						</Div>
						<Div sx={{ mb: 2 }}>
							<InputIcon
								disabled
								inputLabel={"Nomor Telepon Seluler*"}
								placeholder={""}
								value={params.hp}
								leftIcon={<SmartphoneIcon sx={{ fontSize: 24 }} />}
							/>
						</Div>

						<Div sx={{ mb: 2 }}>
							<Typography fontSize={10} >*i.Jika data Email Anda kosong, mohon menghubungi Bagian Keagenan untuk melengkapi data sebelum melakukan registrasi pada {program} ini</Typography>
							<Typography fontSize={10} >ii. Jika data Email Anda salah/tidak sesuai, mohon menghubungi Bagian Keagenan untuk melakukan pengkinian data sebelum melakukan registrasi pada {program}</Typography>
						</Div>


						<Div sx={{ mb: 2 }} className='flex-align-top'>
							<Checkbox
								checked={isChecked}
								onChange={handleCheckboxChange}
								size='small'
								sx={{
									'&.MuiButtonBase-root': { padding: 0 },
									'&.Mui-checked': { color: '#C21B17' }
								}}
							/>
							<Typography fontSize={10} ml={1}>Saya menyetujui <Link onClick={handleClickOpenSnk()}>Syarat dan Ketentuan</Link> dan <Link onClick={handleClickOpenSnk()}>Kebijakan Privasi</Link> yang berlaku. Klik Disini untuk mempelajari <Link onClick={handleClickOpenSnk()}>Syarat dan Ketentuan</Link> yang berlaku.</Typography>
						</Div>


					</Div>
				</ContentWrapper>
			}

			{/* 🔥 FOOTER */}
			<MobileFooter>
				<ButtonStyled
					btnText={"Kirim"}
					preset={"primary"}
					onClick={navigateNext}
					disabled={!isChecked}
				/>
			</MobileFooter>

			{params &&
				<SnK openSnK={openSnK} program={program} setOpenSnk={setOpenSnk} params={params} showButton={false} />
			}
		</Div>

	);
};

export default WebViewRegistrasi;